__turbopack_context__.v({
  "my_list_viewing_history_grid": "MyListViewingHistoryGrid-module-scss-module__6VnYpW__my_list_viewing_history_grid",
});
